<template>
  <div class="d-flex flex-column">
    <!--<div class="d-flex justify-content-around">
      <h3>
        <strong>{{ companyName.toUpperCase() }}</strong>
      </h3>
    </div>-->
    <h3 v-show="errorMessage" class="text-danger">
      Error grabbing Dashboard data! {{ errorMessage }}
    </h3>
    <div class="card">
      <div class="card-header">
          <b>Balance Details</b>
      </div>
      <div class="card-body">
        <p>Point-To-Dollar Conversation Rate: <span><b class="text-success">1 USD = {{ ratio }} Points</b> </span></p>
        <p>
          Current Default Form of Payment: <span class="text-primary" v-if="paymentMethods.length > 0"><b>{{ paymentMethods[0].type }}</b></span><br>
          Current Funding Balance: <span><b class="text-success">${{ currentBalanceInDollar }} ({{ Math.abs(balanceInformation.balance_in_points) }} Points)</b> </span>
        </p>
      </div>
    </div>
    <div class="card" v-if="stripeCustomerId">
        <div class="card-header">
          <b>Notifications, Alerts & Settings</b>
        </div>
        <div class="card-body">
          <!--<ul>
            <li><b>Contacts: </b>Here, you can specify the default contacts who will automatically receive notifications regarding funding activities. These notifications are crucial for keeping your designated team informed about financial updates and transactions. Simply add the relevant contacts to ensure they stay in the loop.</li>
            <li><b>Balance Alrerts: </b>This is where you can set up balance alerts based on thresholds and select who receives them. Click on the green person icon to add additional contacts who should also receive these specific alerts. Please note that all default contacts will receive these alerts automatically.</li>
            <li><b>Reload Threshold: </b>This is where you can arrange for your funding to automatically reload once it reaches a certain minimum balance. Simply specify the minimum balance needed to trigger the auto-reload and enter the amount you want to reload when that threshold is met.</li>
          </ul>-->
          <!-- Tabs navs -->
          <ul class="nav nav-tabs mb-3" id="ex1" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="ex1-tab-1" data-toggle="tab" href="#ex1-tabs-1" role="tab"
                  aria-controls="ex1-tabs-1" aria-selected="true">Default Contacts</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="ex1-tab-2" data-toggle="tab" href="#ex1-tabs-2" role="tab" >Balance Alerts</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="ex1-tab-3" data-toggle="tab" href="#ex1-tabs-3" role="tab" >Reload Threshold</a>
            </li>
          </ul>
          <!-- Tabs navs -->
          
          <div class="tab-content" id="ex1-content">
              <!-- Contact Tab -->
              <div class="tab-pane fade show active" id="ex1-tabs-1" role="tabpanel" aria-labelledby="ex1-tab-1">
                <h5 v-show="errorMessage" class="text-danger">
                  {{ errorMessage }}
                </h5>
                <h5 v-show="successMessage" class="text-success">
                  {{ successMessage }}
                </h5>
                <p>Here, you can specify the default contacts who will automatically receive notifications regarding funding activities. These notifications are crucial for keeping your designated team informed about financial updates and transactions. Simply add the relevant contacts to ensure they stay in the loop.</p>
                <div class="form-group row">
                  <label  class="col-sm-2 col-form-label">Contact</label>
                  <div class="col-sm-4">
                    <div class="form-group mb-2">
                      <input type="text" class="form-control" v-model="contactName" placeholder="Enter Name">
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group mb-2">
                      <input type="email" class="form-control" v-model="contactEmail" placeholder="Enter Email">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <button v-if="!updateFundingId" type="button" class="btn btn-primary" :disabled="disabledButton" @click="addFundingSettings('Contact')">Add
                      <span v-if="disabledButton"><i class="fa fa-spinner fa-spin"></i></span>
                    </button>
                    <button v-else type="button" class="btn btn-primary" :disabled="disabledButton" @click="updateFundingSetting('Contact')">Update
                      <span v-if="disabledButton"><i class="fa fa-spinner fa-spin"></i></span>
                    </button>
                  </div>
                </div>
                <div>
                  <table class="table" v-if="commonContacts.length > 0">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="contact in commonContacts" :key="contact.id">
                        <td>{{ contact.name }}</td>
                        <td>{{ contact.value }}</td>
                        <td>
                          <a href="javascript:void(0)" @click="editSetting(contact)"><i class="far fa-edit text-primary"></i></a>
                          &nbsp;<a href="javascript:void(0)" @click="deleteFundingSetting(contact.id)"><i class="fa fa-trash text-danger" aria-hidden="true"></i></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Balance Alerts Tab -->
              <div class="tab-pane fade show" id="ex1-tabs-2" role="tabpanel" aria-labelledby="ex1-tab-2">
                <h5 v-show="errorMessage" class="text-danger">
                  {{ errorMessage }}
                </h5>
                <h5 v-show="successMessage" class="text-success">
                  {{ successMessage }}
                </h5>
                <p>This is where you can set up balance alerts based on thresholds and select who receives them. Click on the green person icon to add the contacts who should receive these specific alerts.</p>
                <div class="form-group row">
                  <label  class="col-sm-2 col-form-label">Balance Alerts</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="alertName" placeholder="Alert Name">
                      <div class="input-group-prepend">
                        <span class="input-group-text"> <= </span>
                      </div>
                      <input type="text" class="form-control" v-model="alertAmount" placeholder="Enter $ Amount">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <button v-if="!updateFundingId" type="button" class="btn btn-primary" :disabled="disabledButton" @click="addFundingSettings('BalanceAlerts')">Add
                      <span v-if="disabledButton"><i class="fa fa-spinner fa-spin"></i></span>
                    </button>
                    <button v-else type="button" class="btn btn-primary" :disabled="disabledButton" @click="updateFundingSetting('BalanceAlerts')">Update
                      <span v-if="disabledButton"><i class="fa fa-spinner fa-spin"></i></span>
                    </button>
                  </div>
                </div>
                <div>
                  <table class="table" v-if="balanceAlerts.length > 0">
                    <thead>
                      <tr>
                        <th scope="col">Balance Alert Name</th>
                        <th scope="col">Balance Threshold</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="alert in balanceAlerts" :key="alert.id">
                        <td>{{ alert.name }}</td>
                        <td>{{ new Intl.NumberFormat('en-US').format(alert.value) }}</td>
                        <td>
                          <a href="javascript:void(0)" @click="editSetting(alert)"><i class="far fa-edit text-primary"></i></a>
                          &nbsp;<a href="javascript:void(0)" @click="openAlertWiseContactModal(alert.id, alert.name)"><i class="far fa-user text-success" title="Mention contacts who should receive alerts for this."></i></a>
                          &nbsp;<a href="javascript:void(0)" @click="deleteFundingSetting(alert.id)"><i class="fa fa-trash text-danger" aria-hidden="true"></i></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Reload Threshold -->
              <div class="tab-pane fade show" id="ex1-tabs-3" role="tabpanel" aria-labelledby="ex1-tab-3">
                <p>This is where you can arrange for your funding to automatically reload once it reaches a certain minimum balance. Simply specify the minimum balance needed to trigger the auto-reload and enter the amount you want to reload when that threshold is met.</p>
                <div class="form-group row">
                  <label  class="col-sm-2 col-form-label">Reload Threshold</label>
                  <div class="col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><=</span>
                      </div>
                      <input type="text" class="form-control" v-model="minBalanceAmount" placeholder="Minimum balance for auto reload">
                      <input type="text" class="form-control" v-model="autoReloadAmount" placeholder="Auto reload $ amount">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <button type="button" class="btn btn-primary" :disabled="disabledButton" @click="addFundingSettings('Reload')">Save
                      <span v-if="disabledButton"><i class="fa fa-spinner fa-spin"></i></span>
                    </button>
                  </div>
                </div>
              </div>
          </div>

          <b-modal :title="modalTitle" size="lg"
            v-model="alertContactListModal"
            visible hide-footer
            @close="alertContactListModal = false">
            <div>
              <h5 v-show="errorMessage" class="text-danger">
                  {{ errorMessage }}
                </h5>
                <h5 v-show="successMessage" class="text-success">
                  {{ successMessage }}
                </h5>
              <div class="form-group row">
                <label  class="col-sm-2 col-form-label">Contact</label>
                <div class="col-sm-4">
                  <div class="form-group mb-2">
                    <input type="text" class="form-control" v-model="contactName" placeholder="Enter Name">
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group mb-2">
                    <input type="text" class="form-control" v-model="contactEmail" placeholder="Enter Email">
                  </div>
                </div>
                <div class="col-sm-2">
                  <button v-if="!updateFundingId" type="button" class="btn btn-primary" :disabled="disabledButton" @click="addFundingSettings('Contact')">Add
                    <span v-if="disabledButton"><i class="fa fa-spinner fa-spin"></i></span>
                  </button>
                  <button v-else type="button" class="btn btn-primary" :disabled="disabledButton" @click="updateFundingSetting('Contact')">Update
                      <span v-if="disabledButton"><i class="fa fa-spinner fa-spin"></i></span>
                  </button>
                </div>
              </div>
              <div>
                <table class="table" v-if="balanceAlertsContacts.length > 0">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="contact in balanceAlertsContacts" :key="contact.id">
                      <td>{{ contact.name }}</td>
                        <td>{{ contact.value }}</td>
                      <td>
                        <a href="javascript:void(0)" @click="editSetting(contact)"><i class="far fa-edit text-primary"></i></a>
                        &nbsp;<a href="javascript:void(0)" @click="deleteFundingSetting(contact.id)"><i class="fa fa-trash text-danger" aria-hidden="true"></i></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>  
            </div>
          </b-modal>
        </div>
    </div>
    </div>
    <!--<b-spinner
      v-if="loadingInitialData"
      variant="primary"
      label="Spinning"
    ></b-spinner>
    <div v-else class="d-flex">
      <b-table
        class="halfBasis"
        striped
        hover
        :items="items"
        :fields="fields"
      ></b-table>
    </div>-->
    <!--<h2>Recent Transactions</h2>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
      @change="getTransactionReports"
    ></b-pagination>

    <p class="mt-3">Current Page: {{ currentPage }}</p>
    <b-table
      class=""
      striped
      hover
      :items="transactionReports.transaction_records"
      :fields="transactionFields"
    ></b-table>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetBalance, GetPaymentMethods } from "@/api/funding";
import { getSumTransaction } from "@/api/transaction-report";
import moment from "moment";
import FrontendService from '../../../../../services/FrontendService';
export default {
  name: "DashboardComponent",
  data() {
    return {
      disabledButton: false,
      successMessage:"",
      // Add Contacts
      contactName: "",
      contactEmail: "",
      fundingSettingsDetail: [],
      commonContacts: [],

      // Alerts
      alertName: "",
      alertAmount: "",
      balanceAlerts: [],
      parent_id: null,
      balanceAlertsContacts: [],
      modalTitle:"",

      //Reload
      minBalanceAmount: "",
      autoReloadAmount: "",

      updateFundingId: "",

      alertContactListModal: false,
      paymentMethods: [],
      currentBalanceInDollar: 0,
      loadingInitialData: true,
      errorMessage: "",
      fields: ["entry", "points", "dollars"],

      transactionFields: [
        { key: "order_number", label: "Order #" },
        { key: "quantity", label: "Quantity" },
        { key: "date", label: "Transaction Date", sortable: true },
        { key: "client_name", label: "Business Unit" },
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "type", label: "Transaction Type" },
        { key: "product_name", label: "Product Name" },
        { key: "points", label: "Points Cost" },
        { key: "dollars", label: "Product Cost" },
      ],
      balanceInformation: {},
      mtdAllocations: {},
      mtdRedemptions: {},
      ytdAllocations: {},
      ytdRedemptions: {},
      perPage: 10,
      currentPage: 1,
      form: { start_date:  new moment().startOf("year").format("YYYY-MM-DD") + "T00:00:00Z",
        end_date:new moment().endOf("year").format("YYYY-MM-DD") + "T23:59:59Z",
        is_all_clients_selected: true,
        client_ids: [],
        is_all_programs_selected: true,
        program_ids: [],
        is_all_user_code_selected: true,
        user_codes: [],
        is_all_transactions_selected: true,
        show_my_transaction: false,
        transaction_types: [],
        show_total: false,
        sort_on: "date",
        sub_total_by: [],
        export_to_excel: false,
        email: ""}
    };
  },
  watch: {
   
  },
  computed: {
    ...mapState({
      companyName: (state) => state.company.name,
      ratio: (state) => state.company.ratio,
      stripeCustomerId: (state) => state.company.stripeCustomerId,
      userClients: (state) => state.user.userClients,
      userEmail: (state) => state.user.email,
    }),
    transactionReports() {
      return this.$store.getters["transactionReport/getTransactionReport"];
    },
    rows() {
      return this.transactionReports.total_records;
    },
    items() {
      return [
        {
          entry: "Points Not Backed By Deposits",
          // a negative balance returned is the amount of points the client has allocated, hence the double negative
          points:
            this.balanceInformation.totalUserPoints -
            -this.balanceInformation.allocatedDeposit,
          dollars: `$${(
            (this.balanceInformation.totalUserPoints -
              -this.balanceInformation.allocatedDeposit) /
            this.ratio
          ).toFixed(2)}`,
        },
        {
          entry: "Points Backed By Deposits",
          // a negative balance returned is the amount of points the client has allocated, hence the double negative, also is returned in cents
          points: -this.balanceInformation.allocatedPoints,
          dollars: `$${-this.balanceInformation.allocatedDeposit.toFixed(2) / 100}`,
        },
        {
          entry: "MTD Allocations",
          points: this.mtdAllocations.totalPoints,
          dollars: `$${this.mtdAllocations.totalDollars.toFixed(2)}`,
        },
        {
          entry: "MTD Redemptions",
          points: this.mtdRedemptions.totalPoints,
          dollars: `$${this.mtdRedemptions.totalDollars.toFixed(2)}`,
        },
        {
          entry: "YTD Allocations",
          points: this.ytdAllocations.totalPoints,
          dollars: `$${this.ytdAllocations.totalDollars.toFixed(2)}`,
        },
        {
          entry: "YTD Redemptions",
          points: this.ytdRedemptions.totalPoints,
          dollars: `$${this.ytdRedemptions.totalDollars.toFixed(2)}`,
        },
      ];
    },
  },
  methods: {
    async getTransactionReports(currPage) {
      console.log("filter");
      await this.$store.dispatch("transactionReport/addTransactionReport", {
        form: this.form,
        params: {
          pg_num: currPage,
          pg_size:this.perPage,
        },
      });

      console.log(this.transactionReports);
    },

    async getMTDAllocations() {
      // MTD Allocations
      try {
        const sDate = new moment().startOf("month").format("YYYY-MM-DD");
        const eDate = new moment().endOf("month").format("YYYY-MM-DD");

        const transactionParams = {
          start_date: sDate + "T00:00:00Z",
          end_date: eDate + "T23:59:59Z",
          transaction_type: "allocDepositAdd",
        };
        const resp = await getSumTransaction(transactionParams);
        console.log(resp);

        if (resp.status != 200) {
          this.errorMessage = resp.data;
          return;
        }
        this.mtdAllocations = resp.data;
      } catch (e) {
        this.errorMessage = e;
      }
    },
    async getMTDRedemptions() {
      // MTD Allocations
      try {
        const sDate = new moment().startOf("month").format("YYYY-MM-DD");
        const eDate = new moment().endOf("month").format("YYYY-MM-DD");

        const transactionParams = {
          start_date: sDate + "T00:00:00Z",
          end_date: eDate + "T23:59:59Z",
          transaction_type: "allocDepositRemove",
        };
        const resp = await getSumTransaction(transactionParams);
        console.log(resp);

        if (resp.status != 200) {
          this.errorMessage = resp.data;
          return;
        }
        this.mtdRedemptions = resp.data;
      } catch (e) {
        this.errorMessage = e;
      }
    },
    async getYTDAllocations() {
      // MTD Allocations
      try {
        const sDate = new moment().startOf("year").format("YYYY-MM-DD");
        const eDate = new moment().endOf("year").format("YYYY-MM-DD");

        console.log(sDate);
        console.log(eDate);

        const transactionParams = {
          start_date: sDate + "T00:00:00Z",
          end_date: eDate + "T23:59:59Z",
          transaction_type: "allocDepositAdd",
        };
        const resp = await getSumTransaction(transactionParams);
        console.log(resp);

        if (resp.status != 200) {
          this.errorMessage = resp.data;
          return;
        }
        this.ytdAllocations = resp.data;
        console.log(this.ytdAllocations);
      } catch (e) {
        this.errorMessage = e;
      }
    },
    async getYTDRedemptions() {
      // MTD Allocations
      try {
        const sDate = new moment().startOf("year").format("YYYY-MM-DD");
        const eDate = new moment().endOf("year").format("YYYY-MM-DD");

        console.log(sDate);
        console.log(eDate);

        const transactionParams = {
          start_date: sDate + "T00:00:00Z",
          end_date: eDate + "T23:59:59Z",
          transaction_type: "allocDepositRemove",
        };
        const resp = await getSumTransaction(transactionParams);
        console.log(resp);

        if (resp.status != 200) {
          this.errorMessage = resp.data;
          return;
        }
        this.ytdRedemptions = resp.data;
        console.log(this.ytdRedemptions);
      } catch (e) {
        this.errorMessage = e;
      }
    },

    addFundingSettings(type) {
      this.updateFundingId = "";
      this.disabledButton = true;
      
      let data;
      if (type == "Reload") {
        for (let i = 0; i <= 1; i++) {
          data = {
            type: type,
            name: (i == 0) ? "minBalanceAmount" : "autoReloadAmount",
            value: (i == 0) ? this.minBalanceAmount : this.autoReloadAmount
          } 
          FrontendService.addFundingSettings(data)
          .then((response) => {
            this.disabledButton = false;
            if (response.status == 200) {
              this.successMessage = response.data.responseMessage
              this.getFundingSettings();
            } else {
              this.errorMessage = response.data.responseMessage
            }
            setTimeout(() => {
                this.errorMessage = ""
                this.successMessage = ""
              }, 1500)
          }).catch((e) => {
            this.disabledButton = false;
          });
        }
      } else {
        if (type == "Contact") {
          data = {
            type: type,
            name: this.contactName,
            value: this.contactEmail,
            parent_id: this.parent_id,
          }
        }
        if (type == "BalanceAlerts") {
          data = {
            type: type,
            name: this.alertName,
            value: this.alertAmount
          }
        }
        FrontendService.addFundingSettings(data)
        .then((response) => {
          this.disabledButton = false;
          this.contactName = "";
          this.contactEmail = "";
          this.alertName = "";
          this.alertAmount = "";
          if (response.status == 200) {
            this.successMessage = response.data.responseMessage
            this.getFundingSettings();
          } else {
            this.errorMessage = response.data.responseMessage
          }
          setTimeout(() => {
              this.errorMessage = ""
              this.successMessage = ""
            }, 1500)
        }).catch((e) => {
          this.disabledButton = false;
        });
      }
    },

    editSetting(settingDetail) {
      this.updateFundingId = settingDetail.id;
      if (settingDetail.type == "Contact") {
        this.contactEmail = settingDetail.value;
        this.contactName = settingDetail.name;
      }
      if (settingDetail.type == "BalanceAlerts") {
        this.alertAmount = settingDetail.value;
        this.alertName = settingDetail.name;
      }
    }, 
    updateFundingSetting(type) {
      this.disabledButton = true;
      let data;
      if (type == "Contact") {
          data = {
            id: this.updateFundingId,
            name: this.contactName,
            value: this.contactEmail,
          }
        }
        if (type == "BalanceAlerts") {
          data = {
            id: this.updateFundingId,
            name: this.alertName,
            value: this.alertAmount
          }
        }
      FrontendService.updateFundingSetting(data)
        .then((response) => {
          this.disabledButton = false;
          if (response.status == 200) {
            this.successMessage = response.data.responseMessage
            this.getFundingSettings();
            this.updateFundingId = ""; this.contactName = ""; this.contactEmail = ""; this.alertName = ""; this.alertAmount = "";
          } else {
            this.errorMessage = response.data.responseMessage
          }
          setTimeout(() => {
            this.errorMessage = ""
            this.successMessage = ""
          }, 1500)
        }).catch((e) => {
          this.disabledButton = false;
        });
    },
    getFundingSettings() {
      FrontendService.getFundingSettings()
        .then((response) => {
          this.fundingSettingsDetail = response.data.data;
          let contactsArray = [];
          let balanceAlerts = [];
          let balanceAlertsContacts = [];
          if (this.fundingSettingsDetail.length > 0) {
            this.fundingSettingsDetail.forEach(async (fundingDetail) => {
              if (fundingDetail.type == "Contact" && fundingDetail.parent_id == null) {
                contactsArray.push(fundingDetail);
              }
              if (fundingDetail.type == "BalanceAlerts") {
                balanceAlerts.push(fundingDetail);
              }
              if (this.parent_id && fundingDetail.type == "Contact" && fundingDetail.parent_id == this.parent_id) {
                balanceAlertsContacts.push(fundingDetail);
              }
              if (fundingDetail.type == "Reload" && fundingDetail.name == "minBalanceAmount") {
                this.minBalanceAmount = fundingDetail.value
              }
              if (fundingDetail.type == "Reload" && fundingDetail.name == "autoReloadAmount") {
                this.autoReloadAmount = fundingDetail.value
              }
            });
            this.commonContacts = contactsArray;
            this.balanceAlerts = balanceAlerts;
            this.balanceAlertsContacts = balanceAlertsContacts;
          }
        }).catch((e) => {
          this.disabledButton = false;
        });
    },
    deleteFundingSetting(id) {
      this.updateFundingId = "";
      if (confirm("Are you sure you want to delete this settings?") == true) {
        FrontendService.deleteFundingSetting({ id: id })
          .then((response) => {
            if (response.status == 200) {
              this.successMessage = response.data.responseMessage
              this.getFundingSettings();
            } else {
              this.errorMessage = response.data.responseMessage
            }
            setTimeout(() => {
              this.errorMessage = ""
              this.successMessage = ""
            }, 1500)
          }).catch((e) => {
            this.disabledButton = false;
          });
      } else {
        
      }
    },
    openAlertWiseContactModal(id, title) {
      this.errorMessage = "";
      this.successMessage = "";
      this.contactEmail = "";
      this.contactName = "";
      this.parent_id = id;
      this.modalTitle = title;
      let balanceAlertsContacts = [];
      if (this.fundingSettingsDetail.length > 0) {
            this.fundingSettingsDetail.forEach(async (fundingDetail) => {
              if (fundingDetail.type == "Contact" && fundingDetail.parent_id == id) {
                balanceAlertsContacts.push(fundingDetail);
              }
            })
      }
      this.balanceAlertsContacts = balanceAlertsContacts;
      this.alertContactListModal = true;
    }
  },
  async created() {
    await this.$store.dispatch("company/fetchCompany"); // TODO all of these things should be persistent
    await this.$store.dispatch("user/fetchProfile");

    try {
      const resp = await GetBalance({
        clientId: parseInt(this.userClients.client),
      });
      console.log(resp);
      if (resp.status != 200) {
        this.errorMessage = resp.data;
      }
      this.balanceInformation = resp.data;
      if (this.balanceInformation.balance_in_dollars <= 0) {
        this.currentBalanceInDollar = Math.abs(this.balanceInformation.balance_in_dollars)
      } else {
        this.currentBalanceInDollar = Math.abs(this.balanceInformation.balance_in_dollars) * -1
      }
      this.currentBalanceInDollar = new Intl.NumberFormat('en-US').format(this.currentBalanceInDollar)
    } catch (e) {
      console.error(e);
      this.errorMessage = e;
    } finally {
    }

    // Get transaction information for mtd and ytd allocations and redemptions
    await this.getMTDAllocations();
    await this.getMTDRedemptions();
    await this.getYTDAllocations();
    await this.getYTDRedemptions();
    this.getFundingSettings();

    // Get initial transaction data
    try {
      await this.getTransactionReports(this.currentPage);
      this.loadingInitialData = false;
    } catch (e) {
      console.error(e);
      this.errorMessage = e;
      this.loadingInitialData = false;
    }

    try {
      const resp = await GetPaymentMethods(this.userClients.client);

      if (resp.status != 200) {
        this.errorMessage = resp.statusText;
        return;
      }
      this.paymentMethods = resp.data.payment_methods;
    } catch (e) {
      this.errorMessage = e;
    }
  },
};
</script>

<style lang="scss" scoped>
.halfBasis {
  flex-basis: 50%;
}
</style>